import { render, staticRenderFns } from "./ResultsOverview.vue?vue&type=template&id=1dd746b4&scoped=true&"
import script from "./ResultsOverview.vue?vue&type=script&lang=js&"
export * from "./ResultsOverview.vue?vue&type=script&lang=js&"
import style0 from "./ResultsOverview.vue?vue&type=style&index=0&id=1dd746b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd746b4",
  null
  
)

export default component.exports